import { render, staticRenderFns } from "./chanpin-16.vue?vue&type=template&id=5f039e65&"
import script from "./chanpin-16.vue?vue&type=script&lang=js&"
export * from "./chanpin-16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports